import { skuDetails } from 'types/sku';

export const getSkuNameFromDetails = (
  details: skuDetails[] | undefined,
  sku: string,
): string => details?.find((d: any) => d._id === sku)?.name || ' - ';
